import React, {useState} from 'react';
import {useInstance} from 'react-ioc';
import {useMutation} from '@apollo/client';
import {Button, Form, Input} from 'antd';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {Store} from '../../model/store/Store';

import {activate, activateVariables} from './__generated__/activate';
import {MUTATION_ACTIVATE} from './auth';

interface ICodeForm {
    code: string;
}

export const Activate = () => {

    const [activate, {loading}] = useMutation<activate, activateVariables>(MUTATION_ACTIVATE);
    const [codeError, setCodeError] = useState<string>('')
    const {auth} = useInstance(Store)

    const onFinish = async (data: ICodeForm) => {
        await activate({
            variables: {
                code: data.code,
            },
            onCompleted: () => {
                auth.needUpdate()
            },
            onError: (err) => {
                setCodeError(err.message)
                auth.needUpdate()
            }
        })
    }

    let errorMessage = undefined;
    switch (codeError) {
        case 'Not valid code': errorMessage = 'Не подходящий код'; break;
        case 'Already activated': errorMessage = 'Такой код уже активирован'; break;
    }

    return (
        <Layout header={<Header title={'Доступ'}/>}>
            <Form layout={'vertical'} onFinish={onFinish} validateTrigger={'onFinish'}
                  style={{textAlign: 'center', marginTop: 80}}>
                <Form.Item name={'code'} label={'Номер сертификата'} rules={[
                    {required: true, message: 'Заполните, пожалуйста'},
                ]}>
                    <Input/>
                </Form.Item>
                <Form.Item>
                    <Button loading={loading} htmlType={'submit'} type={'primary'} block>Далее</Button>
                </Form.Item>
                {codeError &&
                    <Form.Item>
                        <div className={'error'}>
                            {errorMessage}
                        </div>
                    </Form.Item>
                }
            </Form>
        </Layout>

    )
}